import { http } from 'services/http';
import { EXPENSES_GET_MANY, EXPENSES_GET_ONE } from 'api/query-keys.ts';
import type { TEntityIdRes, TUpdateExpenseReq } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

export const useUpdateExpense = (expenseId: number) => {
  return useMutationBase<TEntityIdRes, unknown, TUpdateExpenseReq>({
    mutationFn: async (variables) => {
      const res = await http.patch<TEntityIdRes>(`/v1/expenses/${expenseId}`, variables);
      return res.data;
    },

    invalidateCallback: () => [[EXPENSES_GET_ONE, expenseId], [EXPENSES_GET_MANY]],
  });
};
